export var IResponsiveImages;
(function (IResponsiveImages) {
    /**
     * Return an instance of IResponsiveImages with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IResponsiveImages.build = (partial) => (Object.assign({ mobile_and_above: [], tablet_and_above: [], desktop_and_above: [] }, (partial !== null && partial !== void 0 ? partial : {})));
})(IResponsiveImages || (IResponsiveImages = {}));
